import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import Cards1 from './../block/Cards1'
import HSPortaliBlock from './../block/HSPortaliBlock'
import PhotoGallarySlyder from './../block/PhotoGallarySlyder'
import PosmotriteVideo from './../block/PosmotriteVideo'
import Social from './../block/Social'
import HideContentBlock from './../block/HideContentBlock'
import Raschet from './../block/Raschet'
import Kontakti from './../block/Kontakti'

class HSPortali extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
        />
        <Cards1
          list={data?.nadeznost_list || []}
          title={data?.nadeznost_title || ``}
          rtext={data?.nadeznost_rtext || ``}
          margin={`y`}
          cols={`4`}
        />
        <HSPortaliBlock
          data={data?.hsportali || {}}
          assets_path={assets_path}
        />
        <PhotoGallarySlyder
          data={data?.photogallary || {}}
        />
        <PosmotriteVideo
          data={data?.videos || {}}
          assets_path={assets_path}
          margin={`bottom`}
        />
        <Social
          data={data?.social || {}}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
          vklink={data?.vklink}
          youlink={data?.youlink}
          rutubelink={data?.rutubelink}
        />
        <HideContentBlock
          data={data?.hidecontent || {}}
        />
        <Cards1
          list={data?.priemushestva || []}
          title={data?.priemushestva_title || ``}
          margin={`y`}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
        />
      </>
    )
  }
}

HSPortali.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

HSPortali.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default HSPortali